import  Checkbox  from "@mui/material/Checkbox";
import { Button, FormControlLabel, Link, Switch, TextField } from "@mui/material";
import { Component } from "react";
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { Navigate } from "react-router";


export default class NewBooking extends Component
{
    constructor(props) {
        super(props);
        this.state = {
            permanentBooking: false,
            valueDay: new Date().toISOString().split('T')[0],
            dayIsSet: false,
            valueChair: '',
            valueBuilding: '',
            valueZone: '',
            autoCheckin: false,
            buildings: [],
            zones: [],
            desks: [],
            finish: false
        };

        this.handleChangeDay = this.handleChangeDay.bind(this);
        this.handleChangeChair = this.handleChangeChair.bind(this);
        this.handleChangeBuilding = this.handleChangeBuilding.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChangeAutoCheckin = this.handleChangeAutoCheckin.bind(this);
        this.handleChangeZone = this.handleChangeZone.bind(this);
        this.togglePermanentBooking = this.togglePermanentBooking.bind(this);
    }

    handleChangeAutoCheckin = event => this.setState({autoCheckin: event.target.checked});

    
    updateChairs = valueDay => {
        this.setState({valueDay: valueDay, dayIsSet: true});
        this.setState({valueBuilding: null, valueZone: null, valueChair: null})
        
        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify({"day": valueDay}),
        redirect: "follow"
        };

        fetch("empty_desks", requestOptions)
        .then(result => result.json())
        .then(r => {
            this.setState({buildings: r, zones: [], desks: [], valueBuilding: '', valueZone: null, valueChair: null})
        })
        .catch((error) => console.error(error));
    }

    handleChangeDay = event => {
        const valueDay = event.target.value;
        this.updateChairs(valueDay);
    }

    handleChangeZone = event => {
        const valueZone = event.target.value;
        this.setState({valueZone: valueZone, valueChair: null});
        this.setState({desks: this.state.zones.find(zone => zone.id === valueZone).desks})
    }

    handleChangeChair(event) {
        this.setState({valueChair: event.target.value});
    }

    handleChangeBuilding(event) {
        const valueBuilding = event.target.value;
        this.setState({valueBuilding: valueBuilding, valueChair: null, valueZone: null});
        this.setState({zones: this.state.buildings.find(b => b.id === valueBuilding).zones, desks: []});
    }

    handleSubmit(event){
        const myHeaders = new Headers();
        myHeaders.append('Content-Type', 'application/json');

        const requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: JSON.stringify({
                'day': this.state.valueDay,
                'deskId': this.state.valueChair,
                'zoneId': this.state.valueZone,
                'buildingId': this.state.valueBuilding,
                'permanentBooking': this.state.permanentBooking
            }),
            redirect: 'follow'
        };
        fetch('booking', requestOptions)
        .then(res => this.setState({finish: true}))
        .catch(error => console.error(error));

        event.preventDefault();
    }

    togglePermanentBooking(event) {
        const valuePermanentBooking = event.target.checked;
        this.setState({permanentBooking: valuePermanentBooking});
        var day;
        if(valuePermanentBooking){
            var date = new Date();
            date.setDate(date.getDate()+14);
            day = date.toISOString().split('T')[0];
        }else{
            day = new Date().toISOString().split('T')[0];
        }
        this.setState({valueDay: day});
        this.updateChairs(day);
    }

    render() {
        const pp = this.state.permanentBooking?{input:{readOnly:true}}:{};
        return(<form onSubmit={this.handleSubmit}>
            <Link href='/' className="noMargin">earlydeskbird</Link><br/><br/>
            <FormControlLabel control={<Switch value={this.state.permanentBooking} onChange={this.togglePermanentBooking}/>} label="Platz dauerhaft buchen"/><br/>
            <TextField label="Tag" type="date" onChange={this.handleChangeDay} value={this.state.valueDay} slotProps={pp}/>
            <br/>
            {this.state.dayIsSet && <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }}>
                <InputLabel>Gebäude</InputLabel>
                <Select
                    id="building"
                    value={this.state.valueBuilding}
                    label="Gebäude"
                    onChange={this.handleChangeBuilding}
                >
                    {this.state.buildings.map(building => <MenuItem value={building.id}>{building.name}</MenuItem>)}
                </Select>
            </FormControl>}
            <br/>
            {this.state.dayIsSet && this.state.zones.length > 0 && <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }}>
                <InputLabel>Zone</InputLabel>
                <Select
                    id="zone"
                    value={this.state.valueZone}
                    label="Gebäude"
                    onChange={this.handleChangeZone}
                >
                    {this.state.zones.map(zone => <MenuItem value={zone.id}>{zone.name}</MenuItem>)}
                </Select>
            </FormControl>}
            <br/>
            {this.state.dayIsSet && this.state.desks.length > 0 && <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }}>
                <InputLabel>Desk</InputLabel>
                <Select
                    id="desk"
                    value={this.state.valueChair}
                    label="Desk"
                    onChange={this.handleChangeChair}
                >
                    {this.state.desks.map(desk => <MenuItem value={desk.id}>{desk.name}</MenuItem>)}
                </Select>
            </FormControl>}
            <br/>
            {false && <FormControlLabel
                label="Auto Checkin"
                control={<Checkbox onChange={this.handleChangeAutoCheckin} checked={this.state.autoCheckin}/>}
            />}
            <Button onClick={this.handleSubmit}>Abschließen</Button>
            {this.state.finish && <Navigate replace to='/'/>}
        </form>);
    }
}